import styled from "styled-components";

export const Card = styled.div`
  position: relative;
  border-radius: 8px;
  padding: 1rem;
  border-radius: ${props => props.$borderRadius || '8px'};
  box-shadow: 0 0 2px 1px #dae2f0;
  cursor: pointer;
  transition: ease 0.1s;
  flex: 1;
  background-color: ${props => props.$backgroundColor || 'white'};

  ${props => props.$isOverflow && `
    overflow: hidden;
  `};

  ${props => props.$minWidth && `
    min-width: ${props.$minWidth};
  `};

  ${props => props.$maxWidth && `
    max-width: ${props.$maxWidth};
  `};

  ${props => props.$margin && `
    margin: ${props.$margin};
  `};
  
  &:hover {
    transition: ease 0.1s;

    ${props => !props.$active && `
      box-shadow: 0 0 0 1.5px #bccfea!important;
      transition: ease 0.1s;
    `}
  };

  ${props => props.$active && `
      box-shadow: 0 0 0 2px #ff6200;
      background-color: rgb(255 247 237 / 0.5)!important;
      transition: ease 0.1s;
  ` };
`

export const AreaItems = styled.div`
  display: ${props => props.$display || 'flex'};
  flex-direction: ${props => props.$flexDirection || 'column'};
  width: 100%;

  transition: transform 0.3s ease;
  ${props => props.$shift && `
    transform: translateX(-${props.$shift});
  `};

  ${props => props.$justifyContent && `
    justify-content: ${props.$justifyContent};
  `};

  ${props => props.$alignItems && `
    align-items: ${props.$alignItems};
  `};

  .title {
    color: ${props => props.$active ? '#f97316' : 'rgb(148, 163, 184)'};
    font-weight: ${props => props.$active ? '700' : props.$titleWeight || '600'};
    font-size: var(--font-size-section-title);
  };

  .subtitle {
    font-weight: bold;
    font-size: 1.05rem;
  };

  .totalItems {
    color: rgb(148, 163, 184)!important;
    font-weight: 400;
    font-size: var(--font-size-body);
    margin-top: 0.3rem;
  };
`

export const ContentChildren = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
`

export const DynamicItem = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: white;
  overflow: hidden;
  width: ${props => props.$dynamicClick ? '80px' : '0'};
  transition: width 0.3s ease;
  background-color: aliceblue;
`

export const ContentIcon = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: transparent;
  transition: 0.1s ease;

  &:hover {
    background-color: #dae2f0;
    border-radius: 50%;
    transition: 0.1s ease;
  }
`
